var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSheetWrapper',{staticClass:"popup-content",attrs:{"is-popup":"","fit-content":""}},[_c('AppSheetRow',[_c('AppSheetTitle',{attrs:{"title":_vm.title}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }